import React from 'react';

import { Container, TextField, makeStyles, Grid, } from '@material-ui/core';
import { Button, } from 'rsuite';


const INITIAL_VALUES = Object.freeze({
  name: '',
});


const useStyles = makeStyles({
  cancelBtn: {
    marginRight: '1rem',
    borderColor: '#3B66FF',
    color: '#3B66FF !important',
    background: 'transparent !important',
    boxShadow: 'none',
    borderWidth: 2,
    border: '2px solid #3B66FF !important',
    '&:hover': {
      background: 'transparent !important',
      border: '2px solid #3B66FF !important',
    },
  },
});


/**
 * Type option form
 *
 * @param {Object | undefined} data - type option data
 * @param {() => void} onCancel - cancel callback
 * @param {(data: Object) => boolean} onSubmit - submit callback, returns whether the form should be
 * cleared or not
 */
function TypeOptionForm({ data, onCancel, onSubmit, }) {
  const classes = useStyles();
  const [formData, setFormData] = React.useState(INITIAL_VALUES);
  const [loading, setLoading] = React.useState(false);


  async function _onSubmit() {
    setLoading(true);
    if (await onSubmit({ ...data, ...formData, })) {
      setFormData(INITIAL_VALUES);
    }
    setLoading(false);
  }

  function _onCancel() {
    setFormData(INITIAL_VALUES);
    onCancel();
  }

  function onChange(event) {
    setFormData({
      ...FormData,
      [event.target.name]: event.target.value,
    });
  }

  React.useEffect(() => {
    setFormData(data || INITIAL_VALUES);
  }, [data]);


  return (
    <Container
      disableGutters
      fullWidth
      maxWidth="xl"
    >
      <TextField
        margin="dense"
        label="Nome"
        id="name"
        variant="filled"
        InputProps={{
          disableUnderline: true,
        }}
        value={formData.name}
        onChange={onChange}
        type="text"
        name="name"
      />

      <Grid
        container
        justifyContent="flex-end"
        style={{
          marginTop: '0.5rem',
        }}
      >
        {
          undefined != data ?
          <Button
            appearance="primary"
            className={classes.cancelBtn}
            onClick={_onCancel}
            loading={loading}
          >
            Cancelar
          </Button> :
          null
        }

        <Button
          appearance="primary"
          loading={loading}
          onClick={_onSubmit}
          disabled={formData.name == (data || {}).name}
        >
          Salvar
        </Button>
      </Grid>
    </Container>
  );
}

export default React.memo(TypeOptionForm);
